<template>
  <div class="category-container">
    <div v-for="(item, index) in categories"
         :key="index"
         class="category-item"
         :class="{ selected: mirrorStore.currentCategory === item.index }"
         @click="selectCategory(item.index)">
      <div class="category-img"
           :style="{ backgroundImage: `url(${mirrorStore.currentCategory === item.index ? item.selectedImgSrc : item.imgSrc})` }">
      </div>

      <span>{{ item.text }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMirrorStore } from '../../../index'
import { computed, ref } from 'vue'

import category_model from '../../../assets/mirror_imgs/category_model.png'
import category_selected_model from '../../../assets/mirror_imgs/category_model_selected.png'
import category_dressup from '../../../assets/mirror_imgs/category_dressup.png'
import category_dressup_selected from '../../../assets/mirror_imgs/category_dressup_selected.png'
import category_design from '../../../assets/mirror_imgs/category_design.png'
import category_design_selected from '../../../assets/mirror_imgs/category_design_selected.png'
import { useI18n } from "vue-i18n"

const { t } = useI18n()

// 使用路径别名引入图片
const categories = computed(() => [
  {
    imgSrc: category_model,
    selectedImgSrc: category_selected_model,
    altText: t('home.Category.categoryModel'),
    index: 1,
    text: t('home.Category.categoryModel'),
  },
  {
    imgSrc: category_dressup,
    selectedImgSrc: category_dressup_selected,
    altText: t('home.Category.categoryDressup'),
    index: 2,
    text: t('home.Category.categoryDressup'),
  },
  {
    imgSrc: category_design,
    selectedImgSrc: category_design_selected,
    altText: t('home.Category.categoryDesign'),
    index: 3,
    text: t('home.Category.categoryDesign'),
  }
])

const mirrorStore = useMirrorStore()

const selectCategory = (index: number) => {
  mirrorStore.currentCategory = index
}
</script>

<style scoped lang="less">
.category-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
}

.category-img {
  width: 80px;
  height: 80px;
  margin-bottom: 8px;
  background-size: cover;
  background-position: center;
}

.category-item span {
  font-family: "Resource Han Rounded CN";
  font-weight: bold;
  font-size: 16px;
  color: #3F625D;
  line-height: 36px;
}

.category-item.selected span {
  font-family: Resource Han Rounded CN;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 36px;
  background: linear-gradient(0deg, #3FFFE4 0%, #95FFF0 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
